import Fab from '@material-ui/core/Fab';
import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Add from '@material-ui/icons/Add';
import React from 'react';
import MaterialUiLink from '../components/MaterialUiLink';
import { RouteLocationState } from './WithQueryParams';

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    bottom: theme.spacing(2),
    float: 'right',
    marginTop: theme.spacing(1),
    position: 'sticky'
  }
}));

export interface Props {
  label: string;
  innerText: string;
  to: {pathname: string, state: RouteLocationState};
}

export const FloatButton: React.FC<Props> = (props: Props) => {
  const {label, innerText, to} = props;
  const classes = useStyles();

  return (
    <Fab
      aria-label={label}
      className={classes.fab}
      color={'primary'}
      component={MaterialUiLink}
      to={to}
      variant="extended"
    >
      <Add/> {innerText}
    </Fab>
  );
};
